/* eslint-disable */
import axios from 'axios';
import { getToken, getApiIAToken } from '../store/auth';

let ENV = 'matriz'; // ⬅️ Altere para:'icone', 'matriz', 'ocupacional', 'localhost', 'isas'

let baseURL = '';
let ativarFuncaoMatriz = false;
let ativarFuncaoOcupacional = false;
let base = '';

switch (ENV) {
  case 'matriz':
    baseURL = 'https://smv2drmed.cmremedios.com.br/api/';
    base = 'https://smv2drmed.cmremedios.com.br/';
    ativarFuncaoMatriz = true;
    break;
  case 'ocupacional':
    baseURL = 'https://smv2.cmremedios.com.br/api/';
    base = 'https://smv2.cmremedios.com.br/';
    ativarFuncaoOcupacional = true;
    break;
  case 'localhost':
    baseURL = 'http://localhost:3000/';
    base = 'http://localhost:3000/';
    break;
  case 'isas':
    baseURL = 'http://10.0.0.100:3000/';
    base = 'http://10.0.0.100:3000/';
    break;
  case 'icone':
    baseURL = 'https://icone.drmedpro.com.br/api/';
    base = 'https://icone.drmedpro.com.br/';
    break;
     case 'icone10':
    baseURL = 'http://10.0.0.115:3000/';
    base = 'https://icone.drmedpro.com.br/';
    break;
  default:
    throw new Error('Ambiente não reconhecido');
}
console.log(`Ambiente: ${ENV}, Base URL: ${baseURL}, ${base}`);

export { baseURL, base, ENV };

export const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getToken()
  }
});

export const apiBot = axios.create({
  baseURL: 'https://simplesmedic.herokuapp.com/',
  headers: {
    'Content-Type': 'application/json',
    'x-access-token': getToken()
  }
});

export const relatorioService = axios.create({
  /* baseURL: 'http://localhost:8181/',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiIsImlhdCI6MTc2Nzk5NTg0OCwiZXhwIjoxNzY3OTk5NDQ4fQ.hi792vfhIQl810XQi342V7-nBt6a1T9aMDnhc8468V4`
  } */
 baseURL: 'https://iconereport.drmedpro.com.br/'
});

export const apiWifi = axios.create({
  // baseURL: 'http://10.10.5.10:8181/'
  baseURL: 'http://localhost:8181/'
});

export const apiVoucher = axios.create({
  baseURL: 'https://icone.drmedpro.com.br/',
  headers: {
    'Content-Type': 'application/json',
    'token': 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMCxyZXBvcnRzLWRybWVkcHJvLDIwMjUtMDgtMDggMTU6MDg6MTcifQ.cPaRbvz9jZW-I24-4OXCLz_wEkQP8aVt10AseyFD43A9JbwR99fs0eiRgawW8zAO9KXwA2rZtX9ZNFJhdaEi1A'
  }
});


// Ativar API IA conforme ambiente
export const apiIA = axios.create({
  baseURL: ativarFuncaoMatriz
    ? 'https://iconeapi.drmedpro.com.br'
    : 'https://iconeapi.drmedpro.com.br',
  // baseURL: ativarFuncaoMatriz
  //   ? 'http://localhost:3000'
  //   : 'https://iconeapi.drmedpro.com.br',
  headers: {
    'Content-Type': 'application/json',
    'Authorization':
      'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJmaWxhc212MiJ9.tnqUOJM5UtsuQ4oMd5jvzt5lLT610EUf56dWIecwDDE'
  }
});
